module.exports = __webpack_public_path__ + "static/quote-banner-f79345f60d70a7e512cb9eb3d4106f73.jpg";